// src/pages/ManageTypes.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import TypeManager from './TypeManager';

const ManageTypes = () => {
    return (
        <Box maxWidth="md">
            <TypeManager type="assemblyType" title="Assembly Type" />
            <TypeManager type="edgeType" title="Edge Type" />
        </Box>
    );
};

export default ManageTypes;

